const GET = async ({ params }) => {
  const version = params.version;
  const tag = version.replace("v", "");
  params.name;
  const response = await fetch(
    `https://github.com/carlelieser/glimmr-release/releases/download/${version}/glimmr-${tag}-setup.exe`
  );
  return new Response(response.body);
};
export {
  GET
};
